<template>
    <div class="col-md-12 table-responsive">
        <table class="datatable table table-striped">
            <thead>
                <tr>
                    <th v-for="(header, index) in headers" :key="index" scope="col">{{ header.columnName }}</th>                    
                </tr>
            </thead>
            <tbody>
                <tr v-for="(row, index) in rows" :key="index">
                    <td v-for="(value, indexValue) in row" :key="indexValue">
                        {{ value }}
                    </td>                    
                </tr>                
            </tbody>
        </table>

        <overlay :enabled="loading"></overlay>
    </div>    
</template>

<script>
    import moment from 'moment'
    import notificator from '../mixins/notificator';
    import { mapGetters } from 'vuex'
    
    import Overlay from '@/components/Overlay.vue';

    export default {
        props: ['settings', 'getData'],

        components: {Overlay},   

        mixins: [notificator],

        data() {
            return {
                headers: [],
                rows: [],
                loading: false,
            }
        },

        created() {
            if(this.getData != null) {
                this.getReportData();
            }
        },

        computed: {    
            ...mapGetters([
                'selectedReport',
                'selectedReportLowerbound',
                'selectedReportUpperbound',
            ]),
        },

        watch: {
            getData() {
                if(this.getData != null) {
                    this.getTSData();
                }
            },
        },

        methods: {
            generateRequest() {
                var offset = new Date().getTimezoneOffset();

                var request = {
                    reportName: this.selectedReport,                    
                };

                switch (this.settings.reportInfo['dataFrequency']) {
                    case 'minutely': case 'hourly':
                        // dateFormat = 'DD/MM/YYYY LT';
                        var lower = this['selectedReportLowerbound'].split(" ");
                        request['aqDatetimeLowerbound'] = moment(lower[0], 'DD/MM/YYYY').add(offset, 'minutes').format('YYYY-MM-DD') + 'T' + moment(lower[1], 'HH:mm').add(offset, 'minutes').format('HH:mm:ss') + 'Z';

                        var upper = this['aqDatetimeUpperbound'].split(" ");
                        request['aqDatetimeUpperbound'] = moment(upper[0], 'DD/MM/YYYY').add(offset, 'minutes').format('YYYY-MM-DD') + 'T' + moment(upper[1], 'HH:mm').add(offset, 'minutes').format('HH:mm:ss') + 'Z';

                        // request['aqDatetimeLowerbound'] = moment(this['selectedReportLowerbound'], 'DD/MM/YYYY HH:mm:ss').add(offset, 'minutes').format('YYYY-MM-DD HH:mm:ss');
                        // request['aqDatetimeLowerbound'] = request['aqDatetimeLowerbound'].replace(" ", "T") + "Z";
                        
                        // request['aqDatetimeUpperbound'] = moment(this['selectedReportUpperbound'], 'DD/MM/YYYY HH:mm:ss').add(offset, 'minutes').format('YYYY-MM-DD HH:mm:ss');
                        // request['aqDatetimeUpperbound'] = request['aqDatetimeUpperbound'].replace(" ", "T") + "Z";
                    break;
                    case 'daily':
                        // dateFormat = 'DD/MM/YYYY';
                        request['aqDatetimeLowerbound'] = moment(this['selectedReportLowerbound'], 'DD/MM/YYYY').add(offset, 'minutes').format('YYYY-MM-DD') + 'T23:59:59';
                        request['aqDatetimeUpperbound'] = moment(this['selectedReportUpperbound'], 'DD/MM/YYYY').add(offset, 'minutes').format('YYYY-MM-DD') + 'T23:59:59';
                    break;
                    case 'monthly':
                        // dateFormat = 'MM/YYYY';
                        request['aqDatetimeLowerbound'] = moment('01/' + this['selectedReportLowerbound'], 'DD/MM/YYYY').add(offset, 'minutes').format('YYYY-MM-DD') + 'T23:59:59';
                        request['aqDatetimeUpperbound'] = moment(this['selectedReportUpperbound'], 'MM/YYYY').endOf('month').add(offset, 'minutes').format('YYYY-MM-DD') + 'T23:59:59';
                    break;
                    case 'yearly':
                        // dateFormat = 'YYYY';
                        request['aqDatetimeLowerbound'] = moment('01/01/' + this['selectedReportLowerbound'], 'DD/MM/YYYY').add(offset, 'minutes').format('YYYY-MM-DD') + 'T23:59:59';
                        request['aqDatetimeUpperbound'] = moment('31/12/' + this['selectedReportUpperbound'], 'DD/MM/YYYY').add(offset, 'minutes').format('YYYY-MM-DD') + 'T23:59:59';
                    break;
                }

                return request;
            },

            getReportData() {
                if(!this.ready)
                    this.overlay(true);

                this.$store
                .dispatch('getReportData', this.generateRequest())
                .catch(error => {
                    if(!this.ready)
                        this.overlay(false);

                    this.notify(this.$options.filters.notification({endpoint: 'GetReportData', code: error}));            

                    this.rows = [];

                    if(!this.ready)
                        this.ready = true;
                })
                .then(({data}) => {
                    if(!this.ready)
                    this.overlay(false);

                    this.notify(this.$options.filters.notification({endpoint: 'GetReportData', code: 200}));
                    
                    if(data.headers!= undefined) {
                        this.headers = data.headers;
                    } else {
                        this.headers = [];
                    }

                    if(data.values != undefined) {
                        this.rows = data.values
                    } else {
                        this.rows = [];
                    }
                    
                    if(!this.ready)
                        this.ready = true;
                });          
            },

            overlay(action) {
                this.loading = action;
            }, 
        }
    }
</script>
